'use client';
import { RADIUS_XL } from '@mnd-frontend/ui/shared/tokens';
import styled, { css } from 'styled-components';

export const CardBaseStyle = css`
    border-radius: ${RADIUS_XL};
    overflow: hidden;
`;
const CardBase = styled.div`
    ${CardBaseStyle}
`;

export default CardBase;
